import React, { Dispatch, SetStateAction } from "react";
import { Box, IconButton, Menu, MenuItem, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { CompanyList, Permission } from "../../types/General";
import { UPDATE_TYPES, USER_ROLES } from "../../utils/enums";
import useAuth from "../../hooks/useAuth";

type props = {
  rows: CompanyList[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  setUsers?: any;
  selectedId: number | null;
  setSelectedId: Dispatch<SetStateAction<number | null>>;
  handleDeleteUser: () => void;
  setModalType: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleUserUpdate: any;
  hidePermission: Permission | undefined;
};

const ApprovedCompaniesList = ({
  rows,
  count,
  page,
  onPageChange,
  loading,
  selectedId,
  setSelectedId,
  setModalType,
  setOpen,
  handleUserUpdate,
  hidePermission,
}: props) => {
  const navigate = useNavigate();
  const userData = useAuth();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 300,
      field: "name",
      headerName: "B2B Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>{row?.company_name}</b> {row?.company_country_code}{" "}
              {row?.company_phone_no || "-"} <br />
              {row?.company_email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "storeName",
      headerName: "Representative Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate(`/users/company/${row?.id}`)}>
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "representativeRole",
      headerName: "Representative Designation",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.designation || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "licenseNo",
      headerName: "Trade License No.",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.trade_license_number || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "brn",
      headerName: "BRN.",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.business_registration_number || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.5,
      minWidth: 150,
      field: "visaRequests",
      headerName: "Total Applicants",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.total_applicant || 0}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "address",
      headerName: "Complete Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.address || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.is_active}
            onChange={() =>
              handleUserUpdate(row?.id, !row?.is_active, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => navigate(`/users/company/${selectedId}`)}
                >
                  View
                </MenuItem>
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <MenuItem
                    onClick={() =>
                      navigate(`/users/company/edit/${selectedId}`)
                    }
                  >
                    Edit
                  </MenuItem>
                ) : null}
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_be_delete ? (
                  <MenuItem
                    onClick={() => {
                      setAnchorEl1(null);
                      setModalType("delete");
                      setOpen(true);
                    }}
                  >
                    Delete
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default ApprovedCompaniesList;
